const MOBILE_BREAK_POINT = 959;

export class Utils {
  // -----------------------------------------------
  // viewport切り替え（引数breakpointの幅未満はviewportを固定にする）
  // -----------------------------------------------
  static switchViewport(breakpoint, viewportWidth) {
    try {
      // viewportのセレクタ取得
      const viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        console.warn('Viewport meta tag not found');
        return;
      }

      const value = window.outerWidth > breakpoint 
        ? 'width=device-width,initial-scale=1,viewport-fit=cover' 
        : `width=${viewportWidth}`;
        
      if (viewport.getAttribute('content') !== value) {
        viewport.setAttribute('content', value);
      }
    } catch (error) {
      console.error('Failed to switch viewport:', error);
    }
  }

  // -----------------------------------------------
  // 指定されたidのページの場合True返却
  // -----------------------------------------------
  static isPage(id) {
    try {
      const body = document.querySelector('body');
      return body?.getAttribute('id') === id;
    } catch (error) {
      console.error('Failed to check page id:', error);
      return false;
    }
  }

  // -----------------------------------------------
  // ブラウザがIEの場合True返却
  // -----------------------------------------------
  static isIE() {
    try {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.includes('msie') || userAgent.includes('trident');
    } catch (error) {
      console.error('Failed to detect IE:', error);
      return false;
    }
  }

  // -----------------------------------------------
  // モバイル端末なら true 、それ以外なら false を返す
  // -----------------------------------------------
  static isMobile() {
    try {
      return window.innerWidth <= MOBILE_BREAK_POINT;
    } catch (error) {
      console.error('Failed to detect mobile:', error);
      return false;
    }
  }

  // -----------------------------------------------
  // PCなら true 、それ以外なら false を返す
  // -----------------------------------------------
  static isPc() {
    return !this.isMobile();
  }

  // -----------------------------------------------
  // ブラウザの縦のサイズを取得し、セットする（iOS対策）
  // -----------------------------------------------
  static setHeightFromWindowHight(target) {
    try {
      const element = typeof target === 'string' 
        ? document.querySelector(target) 
        : target;
        
      if (!element) {
        console.warn(`Target element not found: ${target}`);
        return;
      }

      const hSize = window.innerHeight;
      let paddingTop = 0;
      let paddingBottom = 0;
      
      // 必要に応じてパディングを考慮
      // if (Utils.isPc()) {
      //   const computedStyle = getComputedStyle(element);
      //   paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
      //   paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
      // }
      
      element.style.height = `${hSize + paddingTop + paddingBottom}px`;
    } catch (error) {
      console.error('Failed to set height from window height:', error);
    }
  }

  // -----------------------------------------------
  // ページ内リンクの場合Trueを返却する
  // -----------------------------------------------
  static isInPageLink(event) {
    try {
      // ブラウザのURL取得（プロトコル「https:」は削除）
      let pageUrl = `${location.origin}${location.pathname}`;
      pageUrl = pageUrl.replace(location.protocol, '');

      // 最後の文字が「/」なら削除する
      if (pageUrl.endsWith('/')) {
        pageUrl = pageUrl.slice(0, -1);
      }

      // リンクのhref取得（プロトコル「https:」は削除）
      let linkHref = event.currentTarget.getAttribute('href');
      if (!linkHref) {
        return false;
      }
      
      linkHref = linkHref.replace(location.protocol, '');

      // 差分取得
      let diff = linkHref.replace(pageUrl, '');

      // 先頭の文字が「/」なら削除する
      if (diff.startsWith('/')) {
        diff = diff.slice(1);
      }

      return diff.startsWith('#') || diff === '';
    } catch (error) {
      console.error('Failed to check in-page link:', error);
      return false;
    }
  }

  // -----------------------------------------------
  // ポジション移動（スムーズスクロール）
  // -----------------------------------------------
  static movePosition(target) {
    try {
      // href属性値取得
      const href = target.getAttribute('href');
      if (!href || !href.includes('#')) {
        // #がなければ抜ける
        return true;
      }

      // href属性値からターゲットとなるセレクターを取得する
      let targetSelector = '';
      if (href === '#') {
        targetSelector = 'html';
      } else {
        // 末尾の「#○○○」だけを切り出す
        const id = href.split('#');
        targetSelector = `#${id[id.length - 1]}`;
      }

      const targetElement = document.querySelector(targetSelector);
      if (!targetElement) {
        // ターゲット要素が存在しない場合は何もしないで抜ける
        console.warn(`Target element not found: ${targetSelector}`);
        return false;
      }

      // 移動処理
      const header = document.querySelector('.js-header');
      const headerHeight = header ? header.clientHeight : 0;
      const offset = 100; // 追加のオフセット

      // 位置を取得（ヘッダー分の高さを引く、その分だけ移動すればヘッダーと被らない）
      const position = targetElement.getBoundingClientRect().top + 
                      window.pageYOffset - 
                      headerHeight + 
                      offset;

      if (this.isSafari() && typeof jQuery !== 'undefined') {
        jQuery('html, body').animate({ scrollTop: position }, 'swing');
      } else {
        window.scrollTo({ top: position, behavior: 'smooth' });
      }
      
      return false;
    } catch (error) {
      console.error('Failed to move position:', error);
      return false;
    }
  }

  // -----------------------------------------------
  //iOS（iPadOSを含む）かどうかのUA判定
  // -----------------------------------------------
  static isiOS() {
    try {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.includes('iphone') || 
             ua.includes('ipad') || 
             (ua.includes('macintosh') && 'ontouchend' in document);
    } catch (error) {
      console.error('Failed to detect iOS:', error);
      return false;
    }
  }

  static isSafari() {
    try {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.includes('safari') && !ua.includes('chrome');
    } catch (error) {
      console.error('Failed to detect Safari:', error);
      return false;
    }
  }

  // -----------------------------------------------
  // 文字列の場合はTrueを返却する
  // -----------------------------------------------
  static isString(value) {
    return typeof value === 'string' || value instanceof String;
  }

  // -----------------------------------------------
  // デバウンス関数
  // -----------------------------------------------
  static debounce(func, wait, immediate = false) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(this, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(this, args);
    };
  }

  // -----------------------------------------------
  // スロットル関数
  // -----------------------------------------------
  static throttle(func, limit) {
    let inThrottle;
    return function executedFunction(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  // -----------------------------------------------
  // 要素が画面内に表示されているかチェック
  // -----------------------------------------------
  static isElementInViewport(element, threshold = 0) {
    try {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;

      return (
        rect.top >= -threshold &&
        rect.left >= -threshold &&
        rect.bottom <= windowHeight + threshold &&
        rect.right <= windowWidth + threshold
      );
    } catch (error) {
      console.error('Failed to check element visibility:', error);
      return false;
    }
  }
}
